module.exports = __webpack_public_path__ + "static/img/71.93d2473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/71.png
// module id = lR/h
// module chunks = 0